import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import useApp from "../../../utils/useApp";
import { useLocation } from "react-router-dom";
import { currentUrl } from "../../../App";
import { fetchJobs } from "../../../services/httpClient";
import Jobs from "./Jobs";

interface OrgJobsState {
  setOrgToSave: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const OrgJobs = ({
  setOrgToSave,
  setShowToast,
  setToastText,
  setToastBody,
}: OrgJobsState) => {
  const { auth, showMenu }: any = useApp();
  const location = useLocation();
  currentUrl.value = location.pathname;
  const [errMsg, setErrMsg] = useState("");
  const [jobs, setJobs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    getJobs();
  }, [auth?.profile]);

  const getJobs = () => {
    fetchJobs()
      .then((res: any) => {
        const jobs = res[0].data;
        const groupedByDepartment = Object.values(
          jobs.reduce(
            (acc: any, job: any) => {
              acc[job.department] = acc[job.department] || [];
              acc[job.department].push(job);
              return acc;
            },
            {} as Record<string, any[]>,
          ),
        );
        setJobs(groupedByDepartment);
        setIsLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading ? (
        <Container className={showMenu ? "lg div-main-menu" : "lg div-main"}>
          <Button size="sm" className="spinner-button spinner-button-main">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </Button>
        </Container>
      ) : (
        <>
          <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
            {errMsg}
          </p>
          <Row className="mb-4">
            <Col xs={9}>
              <h4 className="app-header-text">Jobs</h4>
            </Col>
            <Col xs={3} className="d-flex justify-content-end">
              <Button
                className="app-primary-color button"
                onClick={() => setShowAdd(true)}
              >
                Create Job
              </Button>
            </Col>
          </Row>
          <Jobs
            jobs={jobs}
            getJobs={getJobs}
            setOrgToSave={setOrgToSave}
            setErrMessage={setErrMsg}
            setShowToast={setShowToast}
            setToastText={setToastText}
            setToastBody={setToastBody}
            showAddJobDept={showAdd}
            setShowAddJobDept={setShowAdd}
          />
        </>
      )}
    </>
  );
};

export default React.memo(OrgJobs);
